import { render, staticRenderFns } from "./ActionItem.vue?vue&type=template&id=2c0225e8"
import script from "./ActionItem.vue?vue&type=script&lang=js"
export * from "./ActionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports